export enum OrganizationType {
  ALL = 'all', // Mayorista y minorista
  B2B = 'b2b', // Mayorista
  B2C = 'b2c', // Minorista
}
